import { render, staticRenderFns } from "./ListServiceQueue.vue?vue&type=template&id=3a02b70e&"
import script from "./ListServiceQueue.vue?vue&type=script&lang=js&"
export * from "./ListServiceQueue.vue?vue&type=script&lang=js&"
import style0 from "./ListServiceQueue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports